export default __webpack_public_path__ + "assets/fonts/PHOSPHATE_PRO_SOLID.TTF";